/** How pressing a deadline is: past or today, within three days, or not yet. */
export type DeadlineLevel = 'today' | 'soon' | 'normal';

/**
 * Calendar days left until the deadline; 0 is today, below 0 has passed.
 *
 * Days, not instants: an inquiry ending at 23:59 tomorrow is "in 1 Tag" all of
 * today, not "Heute" from midday on.
 */
export const daysLeft = (endDate: Date | string, now: Date = new Date()): number => {
    const day = (value: Date): number => Date.UTC(value.getFullYear(), value.getMonth(), value.getDate());

    return Math.round((day(new Date(endDate)) - day(now)) / (24 * 60 * 60 * 1000));
};

export const deadlineLevel = (endDate: Date | string, now: Date = new Date()): DeadlineLevel => {
    const days = daysLeft(endDate, now);

    if (days <= 0) {
        return 'today';
    }

    return days <= 3 ? 'soon' : 'normal';
};

/**
 * The title without the member it starts with, once the member has a column of
 * its own: "Bergbahn Musterberg AG – Schmutzwasserpumpe" reads
 * "Schmutzwasserpumpe".
 */
export const titleWithoutMember = (title: string, member?: string): string => {
    if (!member || !title.toLowerCase().startsWith(member.toLowerCase())) {
        return title;
    }

    const rest = title.slice(member.length).replace(/^\s*[-–—:]\s*/, '');

    // A title that is nothing but the member's name keeps it.
    return rest.length > 0 && rest !== title.slice(member.length) ? rest : title;
};
